import { Card, Modal, Table, Button } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FullScreenSpinner from '../../Layout/FullScreenSpinner';
import { errHandler } from '../../helper/helper';
import { getDailyWorkCashTransaction, getDailyWorkNonCashTransaction } from './GeneralService';
import { generatePDF } from '../../Utils/pdfExport';
import { b } from 'framer-motion/client';



const createData = (data) => {
  let convertedData = (data.map((post) => {
    return {
      number: post.number,
      details: post.details,
      amount: post.amount
    }

  }))
  return convertedData;

}



const DailyWorkTable = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedCell, setSelectedCell] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [date, setDate] = useState(null);
  const [subData, setSubData] = useState([]);
  const [columnIndex, setColumnIndex] = useState(null);
  const [subHeader, setSubHeader] = useState(null);
  const [spinning, setSpinning] = useState(false);


  const branchId = localStorage.getItem("branchId") ? localStorage.getItem("branchId") : '';
  const branchName = localStorage.getItem("branch") ? localStorage.getItem("branch") : '';


  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      render: (_, record, index) => index + 1, // Auto-incremented row number
    },
    {
      title: 'LedgerCode',
      dataIndex: 'ledgerCode',
      key: 'ledgerCode',
    },
    {
      title: 'Cash Transaction',
      children: [
        {
          title: 'Debit',
          dataIndex: 'cashDebit',
          key: 'cashDebit',
          onCell: (record) => ({
            onClick: () => handleCellClick(record.ledgerCode, 'cashDebit'),
          }),
        },
        {
          title: 'Credit',
          dataIndex: 'cashCredit',
          key: 'cashCredit',
          onCell: (record) => ({
            onClick: () => handleCellClick(record.ledgerCode, 'cashCredit'),

          }),
        },
      ],
    },
    {
      title: 'Non Cash Transaction',
      children: [
        {
          title: 'Debit',
          dataIndex: 'nonCashDebit',
          key: 'nonCashDebit',
          onCell: (record) => ({
            onClick: () => handleCellClick(record.ledgerCode, 'nonCashDebit'),
          }),
        },
        {
          title: 'Credit',
          dataIndex: 'nonCashCredit',
          key: 'nonCashCredit',
          onCell: (record) => ({
            onClick: () => handleCellClick(record.ledgerCode, 'nonCashCredit'),
          }),
        },
      ],
    },
  ];

  const subColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      render: (_, record, index) => index + 1, // Auto-incremented row number
    },
    {
      title: 'Number',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },

  ];

  // const handleCellClick = (cellValue, columnIndex) => {
  //   setSelectedCell(cellValue);
  //   setColumnIndex(columnIndex)
  //   if (columnIndex.substring(0, 3) === "non") {
  //     const clarify = (columnIndex.substring(3) === "CashCredit") ? "C" : "D";
  //     let data={
  //       branchId:branchId,
  //       selectedDate:date,
  //       ledgerCode:selectedCell,
  //       cdType:clarify
  //     };
  //     getAllNonCashTransaction(data);
  //   } else {
  //     const clarify = (columnIndex === "cashCredit") ? "C" : "D";
  //     let data={
  //       branchId:branchId,
  //       selectedDate:date,
  //       ledgerCode:selectedCell,
  //       cdType:clarify
  //     }
  //     getAllCashTransaction(data);
  //   }
  //   setModalIsOpen(true);
  // };

  const handleCellClick = (cellValue, columnIndex) => {
    setSelectedCell(cellValue);
    setColumnIndex(columnIndex);

    let data = {
      branchId: branchId,
      selectedDate: date,
      ledgerCode: cellValue,
      cdType: determineCdType(columnIndex)
    };

    if (isNonCashColumn(columnIndex)) {
      getAllNonCashTransaction(data);

    } else {
      getAllCashTransaction(data);
    }
    // setSelectedCell(null);
  };

  const determineCdType = (columnIndex) => {
    if (isNonCashColumn(columnIndex)) {
      return columnIndex.substring(3) === "CashCredit" ? "C" : "D";
    } else {
      return columnIndex === "cashCredit" ? "C" : "D";
    }
  };

  const isNonCashColumn = (columnIndex) => columnIndex.substring(0, 3) === "non";

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };
  const location = useLocation();
  const navigate = useNavigate();


  const totalCredit = tableData.reduce((acc, record) => acc + record.cashCredit, 0).toFixed(2);
  const totalDebit = tableData.reduce((acc, record) => acc + record.cashDebit, 0).toFixed(2);
  const totalNonCashCredit = tableData.reduce((acc, record) => acc + record.nonCashCredit, 0).toFixed(2);
  const totalNonCashDebit = tableData.reduce((acc, record) => acc + record.nonCashDebit, 0).toFixed(2);

  const summaryRow = {
    id: 'total', // Provide a unique key for the summary row
    ledgerCode: 'Total',
    cashDebit: totalDebit,
    cashCredit: totalCredit,
    nonCashCredit: totalNonCashCredit,
    nonCashDebit: totalNonCashDebit,
    isSummaryRow: true
  };
  const totalAmount = subData.reduce((acc, record) => acc + record.amount, 0).toFixed(2);

  const summarySubRow = {
    id: " ",
    number: " ",
    details: 'Total',
    amount: totalAmount,
    isSummaryRow: true

  }

  const summaryRowClassName = (record) => {
    // Add a custom class to the summary row
    return record.isSummaryRow ? 'summary-row' : '';
  };
  const dataSourceWithSummary = [...tableData, summaryRow];
  const dataSourceWithSubSummary = [...subData, summarySubRow];

  const reportDate = location.state.selectedDate.$d

  const formattedDate = moment(reportDate).format("yyyy-MM-DD");

  const getDataFromLocation = () => {
    if (location.state) {
      setDate(formattedDate)
      setTableData(location.state.tableData)
    } else {
      console.log('No data in location.state');
    }
  };
  const getAllCashTransaction = (data) => {
    setSpinning(true);
    getDailyWorkCashTransaction(data).then((res => {
      setSubHeader(res.data.ledgerName);
      let data = createData(res.data.data);
      setSubData(data);
      setModalIsOpen(true);
    })).catch((err) => {
      errHandler(err);
    }).finally(() => {
      setSpinning(false);
    })
  };

  const getAllNonCashTransaction = (data) => {
    setSpinning(true);
    getDailyWorkNonCashTransaction(data).then((res => {
      setSubHeader(res.data.ledgerName);
      let data = createData(res.data.data);
      setSubData(data);
      setModalIsOpen(true);
    })).catch((err) => {
      errHandler(err);
    }).finally(() => {
      setSpinning(false);
    })
  };

  useEffect(() => {
    getDataFromLocation();
  }, [location]);

  return (
    <div style={{ padding: 10 }}>
      <Card style={{ border: '1px solid #f0f0f0', borderRadius: '5px', boxShadow: '0 2px 8px rgba(51, 39, 39, 0.1)' }}>
        <h2 align="center">{branchName} - Samurdhi bank Daily Report - {date}</h2>
        <div style={{ position: 'relative' }}>
          <FullScreenSpinner spinning={spinning} />
          <Table dataSource={dataSourceWithSummary}
            columns={columns}
            bordered pagination={false}
            rowClassName={summaryRowClassName}
            className='daily-work-table'
          />
        </div>
      </Card>


      {modalIsOpen && (
        <Modal
          open={modalIsOpen}
          title={""}
          closable={true}
          footer={null}
          onCancel={handleCloseModal}
          width={1050}

        >
           <div align="right" style={{ marginRight: 50 }}>
            <Button
              onClick={() =>
                generatePDF(`${branchName} - ${selectedCell}-${subHeader} - ${date}`, subColumns, dataSourceWithSubSummary)
              }
              type="primary"
              style={{ marginBottom: 10 }}
            >
              Export PDF
            </Button>
          </div>
          <div>
            <div align="center" >
              <h4>{`${branchName} - ${selectedCell}-${subHeader}-${date}`}</h4>
            </div>

            <Table dataSource={dataSourceWithSubSummary} columns={subColumns} bordered pagination={false}
              rowClassName={summaryRowClassName} className='daily-work-table'
            />

          </div>
        </Modal>
      )}
    </div>
  );
};

export default DailyWorkTable;
